"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _button = _interopRequireDefault(require("@paprika/button"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var types = _interopRequireWildcard(require("../../types"));

var Trigger = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  return /*#__PURE__*/_react["default"].createElement(_button["default"], (0, _extends2["default"])({
    ref: ref
  }, props, {
    isSemantic: false,
    "data-pka-anchor": "panel.trigger"
  }));
});

Trigger.types = {
  kind: types.sidePanelKinds
};
var propTypes = {
  children: _propTypes["default"].node.isRequired
};
var defaultProps = {};
Trigger.propTypes = propTypes;
Trigger.defaultProps = defaultProps;
Trigger.displayName = "Panel.Trigger";
var _default = Trigger;
exports["default"] = _default;
//# sourceMappingURL=Trigger.js.map